import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'concourse-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {

  @Input() title: string = '';
  @Input() message1: string = '';
  @Input() message2: string = '';
  @Input() message3: string = '';
  @Input() yes_label: string = 'Yes';
  @Input() no_label: string = 'No';
  @Input() closeBtn: boolean = false;
  @Input() showMilstdGlbToggle: boolean = false;
  @Input() glbMessage: string = '';
  useMilstdGlb: boolean = true;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onMilstdGlbToggle(event: any): void {
    console.log(event.target.checked);

    this.useMilstdGlb = event.target.checked;
  }

  onConfirm(): void {
    if (this.showMilstdGlbToggle) {
      this.activeModal.close({ action: 'success', useMilstdGlb: this.useMilstdGlb });
    } else {
      this.activeModal.close('success');
    }
  }

}
